<template>
  <form class="page-form" @submit.prevent="submit">
    <Field
      label="Page name"
      placeholder="e.g. About us"
      @input="$v.resource.name.$touch()"
      @handleChange="handleChange"
      v-model="resource.name"
      :error="nameError"/>

    <Field
      label="Show in Menu?"
      type="checkbox"
      @input="$v.resource.show_in_menu.$touch()"
      @handleChange="handleChange"
      v-model="resource.show_in_menu"
      helpText="Should this page be accessible by your site menu and footer?"/>

    <div class="btn-save">
      <Btn :class="{'changes-made': changesMade}">Create page</Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'AddPageForm',

  mixins: [form],

  props: {
    totalPages: Number
  },

  computed: {
    ...errorMessages([
      'menu_weight',
      'show_in_menu',
      'title',
      'description',
      'name',
      'path'
    ]),

    path: {
      get() {
        return this.resource.path
      },

      set(pageName) {
        let path = pageName.replace(/\s+/g, '-').toLowerCase()
        this.resource.path = '/' + path
      }
    }
  },

  methods: {
    setInitialPageWeight() {
      this.resource.menu_weight = this.totalPages + 1
    },

    setInitialPathSlug() {
      this.path = this.resource.name
    }
  },

  components: {
    Btn
  },

  created() {
    this.setInitialPageWeight()
  },

  validations: {
    resource: {
      banner_url: {},
      content_md: {},
      heading_md: {},
      intro_md: {},
      menu_weight: {},
      show_in_menu: {},
      preview_image: {},
      password_protect: {},
      title: {},
      description: {},
      name: {required},
      path: {required}
    }
  },

  watch: {
    'resource.name'() {
      this.setInitialPathSlug()
    }
  }
}
</script>
